import CapacityDetailModal from "./CapacityDetailModal";
import { CapacityDetailModalContainerProps } from "./types";
import { ConnectedProps, connect } from "react-redux";
import { AppDispatch, RootState } from "store";
import {
  dashboardSlotCapacitySelector,
  actions,
} from "reducers/dashboardSlotCapacityModal";
import { DashboardDropdownState } from "reducers/types/dashboardSlotCapacityModal";

const CapacityDetailModalConatiner = (
  props: CapacityDetailModalContainerProps & ConnectorProps
) => {
  return <CapacityDetailModal {...props} />;
};

const mapStateToProps = (state: RootState) => ({
  dropdownState: dashboardSlotCapacitySelector(state).dropdownState,
  slotDetail: dashboardSlotCapacitySelector(state).slotDetail,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getSlotDetail: (slotId: number) => {
    dispatch(actions.getSlotDetailRequest(slotId));
  },
  setDropdownState: (state: DashboardDropdownState) => {
    dispatch(actions.setDropdownState(state));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(CapacityDetailModalConatiner);
